var map = {
	"./components/asistencias/asistencias.module": [
		"./src/app/components/asistencias/asistencias.module.ts",
		"components-asistencias-asistencias-module"
	],
	"./components/catalogos/catalogos.module": [
		"./src/app/components/catalogos/catalogos.module.ts",
		"default~components-catalogos-catalogos-module~components-pagos-pagos-module",
		"common",
		"components-catalogos-catalogos-module"
	],
	"./components/config/config.module": [
		"./src/app/components/config/config.module.ts",
		"components-config-config-module"
	],
	"./components/dashboard/dashboard.module": [
		"./src/app/components/dashboard/dashboard.module.ts",
		"components-dashboard-dashboard-module"
	],
	"./components/pagos/pagos.module": [
		"./src/app/components/pagos/pagos.module.ts",
		"default~components-catalogos-catalogos-module~components-pagos-pagos-module",
		"common",
		"components-pagos-pagos-module"
	],
	"./components/reportes/reportes.module": [
		"./src/app/components/reportes/reportes.module.ts",
		"common",
		"components-reportes-reportes-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;